module.exports = "/images/edited.png?8e59bcd313d871345a936d0ae59485f8";